import { LOGIN } from 'constants/names.js';
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { logEvent } from 'firebase/analytics';
import { getAnalyticsInstance } from 'firebase.js';
import Modal from 'components/Modal';
import Button from 'components/Button';
import UserProfile from 'components/UserProfile';
import { ProfileIcon } from 'assets/icons';
import { AuthWrapper, UserNameWrapper } from './style.js';
import LoginForm from './LoginForm';

export const AuthContainer = () => {
  const isUserAuth = !!useSelector((state) => state.user.data.token);
  const userName = useSelector((state) => state.user.data.email);
  const [isModalShow, setIsModalShow] = useState(false);
  const [isUserProfileShow, setIsUserProfileShow] = useState(false);
  const [shouldPulsate, setShouldPulsate] = useState(false);

  // Log google analytics events
  const analytics = getAnalyticsInstance();

  // Listen for onboarding completion to trigger pulsating animation
  useEffect(() => {
    const handleOnboardingComplete = () => {
      if (!isUserAuth) {
        setShouldPulsate(true);
        // Stop pulsating after 60 seconds
        setTimeout(() => {
          setShouldPulsate(false);
        }, 60000);
      }
    };

    window.addEventListener('onboardingCompleted', handleOnboardingComplete);
    return () =>
      window.removeEventListener(
        'onboardingCompleted',
        handleOnboardingComplete
      );
  }, [isUserAuth]);

  const handleShowModal = useCallback(() => {
    setIsModalShow(true);
    // Stop pulsating when user clicks sign in
    if (shouldPulsate) {
      setShouldPulsate(false);
      // Track sign in button click after onboarding
      logEvent(analytics, 'sign_in_button_clicked', {
        context: 'post_onboarding_pulsate',
        timestamp: new Date().toISOString(),
      });
    }
  }, [shouldPulsate, analytics]);

  const handleShowProfile = useCallback(() => {
    if (!isUserProfileShow) {
      logEvent(analytics, 'select_content', {
        content_type: 'Click on User profile menu',
        content_id: userName,
      });
    }

    setIsUserProfileShow((prevState) => !prevState);
  }, [analytics, isUserProfileShow, userName]);

  const handleCloseModal = useCallback(() => {
    setIsModalShow(false);
  }, []);

  return (
    <>
      <UserProfile isOpen={isUserProfileShow} onClose={handleShowProfile} />
      <AuthWrapper>
        <Modal onClose={handleCloseModal} show={isModalShow}>
          <LoginForm onClose={setIsModalShow} show={isModalShow} />
        </Modal>
        {isUserAuth ? (
          <UserNameWrapper onClick={handleShowProfile}>
            <ProfileIcon />
          </UserNameWrapper>
        ) : (
          <Button
            onClick={handleShowModal}
            pulsate={shouldPulsate}
            title={LOGIN}
          />
        )}
      </AuthWrapper>
    </>
  );
};
